// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__jxKS0","primary":"Button_primary__cKyoo","dark":"Button_dark__3MjW1","secondary":"Button_secondary__p0LQG","blue":"Button_blue__35zdj"};